import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const getManagersThunk = createAsyncThunk("nsdc/get", async () => {
    let response = await api.get("getAllPasscodeData/manager");
    return response.data;
  });